import { useState } from "react";
import { AddOutlined, PersonAddOutlined } from "@material-ui/icons";
import { IconButton } from "@material-ui/core";
import { WithTooltip } from "@components";
import { TableCellProps } from "@search/TableSearch";
import locale from "@bonliva-crm/locale";
import { store } from "@store";
import {
  useAssignToBookingMutation,
  useUnAssignToBookingMutation,
  TimereportKitSupportSearchItemFragment
} from "@graphql";
import Avatar from "@common/Avatar";
import { TimeReportStatus } from "@bonliva-crm/shared";

const AssignToBookingCol = ({
  rowData
}: TableCellProps<TimereportKitSupportSearchItemFragment>) => {
  const [assign, { loading }] = useAssignToBookingMutation({
    // refetchQueries: [BookingKitSupportSearch_Get.OperationName]
  });
  const [unAssign] = useUnAssignToBookingMutation({
    // refetchQueries: [BookingKitSupportSearch_Get.OperationName]
  });
  const [assignedTo, setAssigned] = useState(rowData.bookingAssignedTo);
  const userId = store().user.id;
  const bookingId = rowData.BookingRef.NodeID;
  const handleAssign = async (userId, bookingId) => {
    try {
      assign({ variables: { userId, bookingId } }).then((res) => {
        setAssigned(res.data?.assignToBooking?.bookingAssignedTo);
        if (res.errors) {
          store().snackbars.error(res.errors.join(", "));
        }
      });
    } catch (e) {
      store().snackbars.error(e);
    }
  };

  const handleUnAssign = async (userId: string) => {
    try {
      store().ui.confirmDelete(`${locale.Un_Assign}`, (confirmed) => {
        if (!confirmed) {
          return;
        }
        unAssign({ variables: { userId, bookingId: rowData.BookingRef.NodeID } }).then(
          (res) => {
            setAssigned(res.data?.unAssignToBooking?.bookingAssignedTo);
            if (res.errors) {
              store().snackbars.error(res.errors.join(", "));
            }
          }
        );
      });
    } catch (e) {
      store().snackbars.error(e);
    }
  };
  const count = rowData.TimeReportStatus === TimeReportStatus.SentToFinance ? 2 : 1;

  return (
    <div
      key={rowData._id}
      onClick={(e) => {
        e.stopPropagation();
        e.preventDefault();
      }}
    >
      {assignedTo?.length < count && (
        <>
          <IconButton
            disabled={loading}
            size={"small"}
            onClick={() => handleAssign(userId, bookingId)}
          >
            <AddOutlined />
          </IconButton>
          <IconButton
            size={"small"}
            disabled={loading}
            onClick={() =>
              store().ui.userSelector.open({
                includeActiveUser: true,
                removeDisabled: true,
                selectedUsers: [],
                onSelect: (user) => {
                  handleAssign(user._id, bookingId);
                }
              })
            }
          >
            <PersonAddOutlined />
          </IconButton>
        </>
      )}

      {assignedTo?.map((x) => (
        <WithTooltip title={x.setTo.Name} key={x.setTo.PersonId}>
          <span>
            <Avatar
              onClick={() => handleUnAssign(x.setTo.PersonId)}
              size={"small"}
              name={x.setTo.Name}
              src={""}
            />
          </span>
        </WithTooltip>
      ))}
    </div>
  );
};

export default AssignToBookingCol;
